import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import {formatarCpf, formatarNomeProduto, formatarValorReal} from "../../../../utils/formatar";
import {Col, FormGroup, Row} from 'reactstrap';
import moment from "moment";
import loading from '../../../../assets/images/ajax-loader.gif';
import PropTypes from "prop-types";

@inject("store")
@observer
export class DetalhamentoProrrogacoesAnteriores extends Component {

    static propTypes = {
        textoNenhumResultado: PropTypes.string,
        titulo: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.appStore = this.props.store.appStore;
    }

    nomeObjetoFormat(cell) {
        return _.get(cell, "nome") ? cell.nome: "";
    }

    dateFormat(cell) {
        return cell ? moment(cell).format("DD/MM/YYYY") : "";
    }

    render() {

        const options_table = {
            noDataText: this.props.controller.loadingProrrogacoesAnteriores ? <img src={loading} alt="loading" className="loading"/> : this.props.textoNenhumResultado ? this.props.textoNenhumResultado : "Não há prorrogações anteriores registradas.",
        };

        return (
            <div>
                <div>
                    <h4>{this.props.titulo ? this.props.titulo : "Prorrogações anteriores"}</h4>
                    <BootstrapTable data={ this.props.controller.prorrogacoesAnteriores } maxHeight='400px' striped hover condensed options={options_table}>
                        <TableHeaderColumn width='80' columnTitle dataField='id' isKey tdStyle={{whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }}>#</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 768 ? 'auto' : '150'} columnTitle dataField='justificativa' tdStyle={{ whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }}>Justificativa</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 768 ? '35%' : '300'} columnTitle dataField='detalhamentoJustificativa' tdStyle={{whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }}>Detalhamento da justificativa</TableHeaderColumn>
                        <TableHeaderColumn width={this.appStore.width > 768 ? 'auto' : '150'} columnTitle dataFormat={ formatarNomeProduto } dataField='nomeProduto' tdStyle={{ whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }}>Projeto/centro de resultado/finalidade</TableHeaderColumn>
                        <TableHeaderColumn width='80'  dataField='dataInicialProrrogada' columnTitle dataFormat={ this.dateFormat } tdStyle={{whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }}>Data início</TableHeaderColumn>
                        <TableHeaderColumn width='80' dataField='dataFinalProrrogada' columnTitle dataFormat={ this.dateFormat } tdStyle={{whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }}>Data fim</TableHeaderColumn>
                        <TableHeaderColumn width='80' dataField='codigoArDebito' columnTitle tdStyle={{whiteSpace: 'normal' }} thStyle={{whiteSpace: 'normal' }}>Centro de custo débito</TableHeaderColumn>
                    </BootstrapTable>
                </div>
            </div>
        )
    }
}